import { render, staticRenderFns } from "./AppModalAssinaturas.vue?vue&type=template&id=04ec1102&"
import script from "./AppModalAssinaturas.vue?vue&type=script&lang=js&"
export * from "./AppModalAssinaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports